import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: "Je préparais chaque semaine mes séances pour trois groupes d'âges différents et je passais mes dimanches soir devant mes dossiers. Avec GYMNASTIQUE PRO™, je pars d'une structure claire, je choisis les exercices adaptés et j'ajuste en quelques minutes. J'ai retrouvé du temps pour observer vraiment mes gymnastes.",
  author: 'Camille Lefèvre',
  role: 'Professeure de gymnastique artistique, 29 ans'
}, {
  text: "En tant que responsable technique d'un club de 140 licenciées, je cherchais un outil simple à partager avec mes entraîneurs. Les programmes de progression et les fiches de suivi nous ont permis de parler le même langage et de mieux accompagner chaque enfant, sans alourdir notre organisation.",
  author: 'Julien Moreau',
  role: 'Responsable technique de club, 42 ans'
}, {
  text: "Je suis arrivée dans l'enseignement il y a deux ans et j'avais souvent peur de brûler les étapes avec les débutantes. Les progressions sont présentées avec beaucoup de logique : je sais quoi proposer ensuite et pourquoi. Mes séances sont plus calmes, plus fluides et les filles gagnent en confiance.",
  author: 'Léa Martin',
  role: 'Professeure secteur éveil et initiation, 25 ans'
}, {
  text: 'Le kit du professeur a changé ma façon de préparer la saison. Les feuilles de suivi et les check-lists sont très pratiques pour rester organisée entre les cours, les évaluations et les échanges avec les familles. Tout est professionnel, facile à utiliser et immédiatement exploitable.',
  author: 'Sophie Bernard',
  role: 'Entraîneuse gymnastique artistique, 37 ans'
}, {
  text: "Avec mon groupe de loisirs, je voulais garder le côté ludique tout en proposant de vraies progressions. Les jeux pédagogiques et la bibliothèque d'échauffements me donnent toujours une idée adaptée, même les semaines où je manque de temps. Les enfants sont motivés et moi beaucoup plus serein.",
  author: 'Antoine Dubois',
  role: 'Professeur de gymnastique loisirs, 33 ans'
}];
export function Testimonials() {
  return <section className="py-6 px-4 sm:px-6 bg-brand-ivory border-y-4 border-brand-border" data-id="element-169">
      <div className="text-center mb-4" data-id="element-170">
        <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-brand-navy mb-1 uppercase leading-tight" data-id="element-171">
          ILS UTILISENT DÉJÀ GYMNASTIQUE PRO™
        </h2>
        <p className="text-sm font-heading font-bold text-brand-violet uppercase tracking-wide" data-id="element-172">
          Des professeurs mieux organisés, séance après séance
        </p>
      </div>
      <div className="flex flex-col gap-3" data-id="element-173">
        {testimonials.map(testimonial => <article key={testimonial.author} className="bg-white border border-brand-border p-4 rounded-lg shadow-sm" data-id="element-174">
            <div className="flex gap-1 mb-2" data-id="element-175">
              {[...Array(5)].map((_, index) => <StarIcon key={index} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-176" />)}
            </div>
            <p className="text-brand-text font-medium mb-3 leading-snug italic text-sm" data-id="element-177">
              « {testimonial.text} »
            </p>
            <div className="border-t border-brand-border pt-2.5 flex items-center gap-3" data-id="element-178">
              <div className="w-9 h-9 rounded-full bg-brand-violet/10 flex items-center justify-center text-brand-violet font-heading font-bold text-sm border border-brand-violet/20" data-id="element-179">
                {testimonial.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-180">
                <p className="font-heading font-bold text-brand-navy text-sm" data-id="element-181">
                  {testimonial.author}
                </p>
                <p className="text-[11px] text-brand-muted font-bold uppercase tracking-wide mt-0.5" data-id="element-182">
                  {testimonial.role}
                </p>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}